import React,{useState, useEffect} from 'react';
import './Style.css';
import './Style.scss';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Login from './Component/Login/Login';
import Forgetpaasword from './Component/Login/Forgetpaasword';
import Home from './Component/Home';
import History from './Component/Page/History';
import HistoryDeclared from "./Component/Page/History_declared";
import Wallet from './Component/Page/Wallet';
import Chat from './Component/Page/Chat';
import Play from './Component/Page/Play';
import Transferrespoint from './Component/Page/Transferrespoint';
import Help from './Component/Page/Help';
import ReferCode from './Component/Page/ReferCode';
import Jodi from './Component/Page/Jodi';
import Refer from './Component/Page/Refer';
import Register from './Component/Login/Register';
import Manual from './Component/Page/Manual';
import Playgame from './Component/Page/Playgame';
import Harruf from './Component/Page/Harruf';
import Crossing from './Component/Page/Crossing';
import Playcommon from './Component/Page/Playcommon';
import Transferrespointlist from './Component/Page/Transferrespointlist';
import Copypaste from './Component/Page/Copypaste';
import Profile from './Component/Page/Profile';
import Resulthistory from './Component/Page/Resulthistory';
import Termsandcondition from './Component/Page/Termsandcondition';
import Notification from './Component/Page/Notification';
import Appdetails from './Component/Page/Appdetails';
import Gameposting from './Component/Page/Gameposting';
import Bonusreport from './Component/Page/Bonusreport';
import Withdrawalchat from './Component/Page/Withdrawalchat';
import Depositchat from './Component/Page/Depositchat';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import '.././src/assets/fonts/font1/stylesheet.css';
import '.././src/assets/fonts/font-2/stylesheet.css';
import Header from ".././src/Component/Header/Header";
import Footer from ".././src/Component/Footer";
import { isMobile } from 'react-device-detect';

import axios from "axios";
import { Window } from 'react-bootstrap-icons';



function App() {
  const [status, setStatus] = useState('');
console.warn(status)
  const clearApplicationCache = async () => {
    try {
      const cacheNames = await caches.keys(); 
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      setStatus('Application cache cleared successfully.');
    } catch (error) {
      setStatus('Error clearing application cache.');
      console.error('Error clearing application cache:', error);
    }
  };
  useEffect(() => {
    clearApplicationCache();
    loaduser1();
  }, []); 

  const [banned, setbanned] = useState([]);
  console.warn("banned",banned)
  if (banned == 1) {
    localStorage.clear();
    window.location.href = "/login";
}



    const loaduser1 = async () => {
      try {
          const user_id = localStorage.getItem("userid");
          const dev_id = localStorage.getItem("dev_id");
  
          if (!user_id || !dev_id) {
              console.warn("🚨 Missing user_id or dev_id in localStorage.");
              return;
          }
  
          const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;
  
          // JSON request payload
          const requestData = {
              app_id: process.env.REACT_APP_API_ID,
              user_id:user_id,
              dev_id:dev_id,
          };
  
          // Sending request as JSON
          const response = await axios.post(url, requestData, {
              headers: {
                  "Content-Type": "application/json"
              }
          });
  
          // Axios automatically parses JSON response
          const objectRes = response.data;
  
          if (objectRes) {
              setbanned(objectRes.banned || false); // Default to false if undefined
              console.warn("✅ User data loaded successfully.");
          } else {
              console.warn("⚠️ No user data received from API.");
          }
  
      } catch (error) {
          console.error("🚨 Error fetching user profile:", error);
      }
  };

  useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get("ref");

  if (ref) {
    localStorage.setItem("refCodeeee", ref); 
    console.log("Referral Code stored:", ref);
  }
}, []);
////////////////////
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get("ref");

  if (ref) {
    localStorage.setItem("refCodeeee", ref);
    console.log("Referral Code stored:", ref);

    // ✅ Reload सिर्फ एक बार करें
    const hasReloaded = sessionStorage.getItem("hasReloaded");
    if (!hasReloaded) {
      sessionStorage.setItem("hasReloaded", "true");
      window.location.reload();
    }
  }
}, []);

  return (
    <>
      {/* {isMobile && */}
        <BrowserRouter status>
          <Routes>
            <Route
              path="/*"
              element={
                <div>
                  <Header />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Wallet" element={<Wallet />} />
                    <Route path="/Chat" element={<Chat />} />
                    <Route path="/History" element={<History />} />
                    <Route
                    path="/History-declared"
                    element={<HistoryDeclared />}
                  />
                    <Route path="/Play" element={<Play />} />
                    <Route path="/Transferrespoint" element={<Transferrespoint />} />
                    <Route path="/Playgame" element={<Playgame />} />
                    <Route path="/Playcommon" element={<Playcommon />} />
                    <Route path="/Transferrespointlist" element={<Transferrespointlist />} />
                    <Route path="/Notification" element={<Notification />} />
                    <Route path="/Help" element={<Help />} />
                    <Route path="/Jodi" element={<Jodi />} />
                    <Route path="/Refer" element={<Refer />} />
                    <Route path="/Manual" element={<Manual />} />
                    <Route path="/Harruf" element={<Harruf />} />
                    <Route path="/Crossing" element={<Crossing />} />
                    <Route path="/Copypaste" element={<Copypaste />} />
                    <Route path="/Profile" element={<Profile />} />
                    <Route path="/Resulthistory" element={<Resulthistory />} />
                    <Route path="/Appdetails" element={<Appdetails />} />
                    <Route path="/Termsandcondition" element={<Termsandcondition />} />
                    <Route path="/Bonusreport" element={<Bonusreport />} />
                    <Route path="/ReferCode" element={<ReferCode />} />


                  </Routes>
                  <Footer />
                </div>
              }
            />
            <Route path="/Withdrawalchat" element={<Withdrawalchat />} />
            <Route path="/Depositchat" element={<Depositchat />} />
            <Route path="/Gameposting" element={<Gameposting />} />
            <Route path="/Register" element={<Register />} /> 
            <Route path="/Forgetpaasword" element={<Forgetpaasword />} /> 
            <Route path="/Playgame" element={<><Playgame /><Header /> </>} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>

      {/* } */}
    </>
  );
}

export default App;
